import React from 'react'
import { Link, useParams } from 'react-router-dom'
import SelectedConnector from '../ConnectorPanel/Connectors/SelectedConnector/SelectedConnector'
import PageLoader from '../../../SharedComponents/PageState/PageLoader'
import { describeConnection, useConnection } from '../../../../features/connections/connectionsApi'
import useEntitySummaries from '../../../../features/syncReports/useEntitySummaries'
import { PATH } from '../../../../app/routes'

const BackLink = () => (
    <Link to={PATH.MY_PRODUCTS} className="backToProducts">&larr; Back to My Products</Link>
)

const ProductDetailPanel = () => {
    const { connectorId } = useParams()
    const { connection, connectionCount, isLoading } = useConnection(connectorId)
    const summaries = useEntitySummaries(connection)

    if (!connection) {
        if (isLoading) {
            return <PageLoader message="Loading connector..." />
        }
        return (
            <div className="mp-empty-state">
                {connectionCount > 0 ? 'Connector not found.' : 'No connectors found.'}{' '}
                <Link to={PATH.MY_PRODUCTS}>Back to My Products</Link>
            </div>
        )
    }

    return (
        <>
            {summaries.isFetching ? (
                <div className="loaderNewContainer">
                    <div className="loading-spinner"></div>
                </div>
            ) : null}
            <BackLink />
            <div className="row">
                <div className="card custom_mn_card">
                    <SelectedConnector
                        connector={describeConnection(connection)}
                        businessEntitiesSource={summaries.source}
                        businessEntitiesTarget={summaries.target}
                    />
                </div>
            </div>
        </>
    )
}

export default ProductDetailPanel
